import React from "react";
import { MultiColumnList, TextLink } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
export var PublisherPrefixHistoryTable = function (_a) {
    var prefixes = _a.prefixes, isLoading = _a.isLoading;
    var history = useHistory();
    var intl = useIntl();
    var handlePublisherClick = function (publisherSourceId) {
        history.push("/brlegaldeposits/publishers?detail=".concat(publisherSourceId));
    };
    var emptyMessage = isLoading ? (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.loading" })) : (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publisher.prefixHistory.noData" }));
    return (React.createElement(MultiColumnList, { contentData: prefixes, columnMapping: {
            value: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publisher.prefixHistory.column.value" })),
            publisher: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publisher.prefixHistory.column.publisher" })),
            status: (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publisher.prefixHistory.column.status" })),
        }, formatter: {
            value: function (item) {
                if (!item.formattedPublisherPrefix)
                    return "-";
                return "".concat(item.agency, " ").concat(item.formattedPublisherPrefix);
            },
            publisher: function (item) {
                var _a, _b;
                var publisherName = ((_a = item.publisher) === null || _a === void 0 ? void 0 : _a.name) || "-";
                var publisherSourceId = (_b = item.publisher) === null || _b === void 0 ? void 0 : _b.sourceId;
                return publisherSourceId ? (React.createElement(TextLink, { onClick: function () { return handlePublisherClick(publisherSourceId); } }, publisherName)) : (publisherName);
            },
            status: function (item) {
                return item.status
                    ? intl.formatMessage({
                        id: "ui-br-legaldeposits.publisher.prefixHistory.status.".concat(item.status),
                    })
                    : "-";
            },
        }, visibleColumns: ["value", "publisher", "status"], isEmptyMessage: emptyMessage, interactive: false }));
};
